import React from 'react'
import Title from '../../../../components/typography/title.component'
import Container from '../../../../components/layout/container.component'
import SearchForm from './components/search-form.component'
import FontAwesome from 'react-fontawesome'
import ModalConfirmation from './../../../../components/modal/modal-confirmation.component'
import AccordionSecondary from './../../../../components/accordion/accordion-secondary.component'
import PaginationComponent from './../../../../components/pagination/pagination.component'
import { PRIMARY_COLOR } from '../../../../styles/colors.style'
import { routes } from './../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { maskHelper } from './../../../../helpers/mask.helper'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../actions/toast.actions'
import { ClientService } from './../../../../services/client.service'
import { setUserPermissions } from '../../../../helpers'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { AdminService } from '../../../../services/admin.service'

class ClientSearchPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			active: true,
			city: '',
			cpf: '',
			moveflexNumber: '',
			name: '',
			state: '',
			modalTitle: '',
			modalMessage: '',
			hasMuvicard: 'ALL',
			modalIsOpen: false,
		}
		this.id = null
		this.active = null
		this.getAccordionItems = () => getAccordionItems.call(this)
		this.paginationRenderRow = paginationRenderRow.bind(this)
		this.onResult = onResult.bind(this)
		this.handleSubmit = handleSubmit.bind(this)
	}

	componentDidUpdate(prevProps) {
		if (prevProps.loading && !this.props.loading) {
			this.refs.pagination.reload()
		}
	}

	componentDidMount() {
		const { user } = this.props
		if (this.refs.pagination) this.refs.pagination.reload()

		setUserPermissions(user)
	}

	render() {
		const {
			active,
			city,
			cpf,
			moveflexNumber,
			name,
			state,
			modalTitle,
			modalMessage,
			modalIsOpen,
			hasMuvicard,
		} = this.state

		const { user } = this.props
		return (
			<Container>
				<Title>Clientes</Title>
				<AccordionSecondary
					arrow={false}
					multiple={false}
					noClickable
					noAnimated
					items={this.getAccordionItems()}
				/>
				<div data-permission="6EC278D8BBAD4022FB5A1EA6D295285E69896208">
					<PaginationComponent
						user={user}
						ref={'pagination'}
						getData={ClientService.search}
						headers={paginationHeaders}
						params={{
							active,
							city,
							cpf,
							moveflexNumber,
							name,
							state,
							hasMuvicard,
						}}
						rowsPerPage={50}
						sortable={paginationSortable}
						renderRow={this.paginationRenderRow}
					/>
				</div>
				<ModalConfirmation
					isOpen={modalIsOpen}
					title={modalTitle}
					onResult={this.onResult}>
					{modalMessage}?
				</ModalConfirmation>
			</Container>
		)
	}
}

const paginationHeaders = [
	{ header: 'Nome', key: 'name' },
	{ header: 'Número Muviflex', key: 'moveflexNumber' },
	{ header: 'CPF', key: 'cpf' },
	{ header: 'Cidade', key: 'city' },
	{ header: 'UF', key: 'state' },
	{ header: 'Situação', key: 'identityUserId', align: 'center' },
	{ header: 'Muvicard', key: 'hasMuvicard', align: 'center' },
]

const paginationSortable = {
	defaultOrder: 'asc',
	cols: [
		{ key: 'name' },
		{ key: 'moveflexNumber' },
		{ key: 'cpf' },
		{ key: 'city' },
		{ key: 'state' },
		{ key: 'hasMuvicard' },
	],
}

function getAccordionItems() {
	return [
		{
			title: 'Filtros',
			content: <SearchForm ref={'form'} onSubmit={this.handleSubmit} />,
		},
	]
}

function paginationRenderRow(rowData, headers) {
	return headers.map(({ key }) => {
		const cellData = rowData[key]
		const id = rowData['identityUserId']
		const active = rowData['active']
		if (key == 'identityUserId') {
			return (
				<td key={key} align="center">
					<FontAwesome
						style={active ? { color: PRIMARY_COLOR } : {}}
						name={active ? 'toggle-on' : 'toggle-off'}
						size="lg"
						title={active ? 'Usuário ativo' : 'Usuário inativo'}
						onClick={(e) => {
							e.stopPropagation()
							this.id = id
							this.active = active
							this.setState({
								modalTitle: `${active ? 'Inativar' : 'Ativar'} cliente`,
								modalMessage: `Confirma a ${
									active ? 'inativação' : 'ativação'
								} do cliente ${rowData['name']}`,
								modalIsOpen: true,
							})
						}}
					/>
				</td>
			)
		} else if (key == 'cpf') {
			const cpfMasked = maskHelper.applyCpf(cellData)
			return (
				<td key={key} onClick={viewClient.bind(this, id)}>
					<span title={cpfMasked}>{cpfMasked}</span>
				</td>
			)
		} else {
			const align = key == 'hasMuvicard' ? 'center' : ''
			return (
				<td key={key} align={align} onClick={viewClient.bind(this, id)}>
					<span title={cellData}>{cellData}</span>
				</td>
			)
		}
	})
}

function onResult(confirmed) {
	this.setState({ modalIsOpen: false })
	if (!confirmed) return
	const { showLoading, hideLoading, success, danger } = this.props
	showLoading()
	if (this.active) {
		AdminService.inactivateUser({ userId: this.id })
			.then((response) => {
				hideLoading()
				if (response.success) {
					success({ message: 'Cliente inativado com sucesso' })
					this.refs.pagination.reload()
				} else
					danger({
						message: response.errors[0],
					})
			})
			.catch(() => {
				hideLoading()
				danger({
					message:
						'Não foi possível inativar o cliente, por favor tente novamente mais tarde',
				})
			})
	} else {
		AdminService.activateUser({ userId: this.id })
			.then((response) => {
				hideLoading()
				if (response.success) {
					success({ message: 'Cliente ativado com sucesso' })
					this.refs.pagination.reload()
				} else
					danger({
						message: response.errors[0],
					})
			})
			.catch(() => {
				hideLoading()
				danger({
					message:
						'Não foi possível ativar o cliente, por favor tente novamente mais tarde',
				})
			})
	}
}

function viewClient(clientId) {
	this.props.history.push(`${routes.ADMIN}/cliente/${clientId}`)
}

function handleSubmit({
	active,
	city,
	cpf,
	moveflexNumber,
	name,
	state,
	hasMuvicard,
}) {
	this.setState(
		{
			active: active === 'none' ? '' : active,
			city,
			cpf,
			moveflexNumber,
			name,
			state: state == 'none' ? '' : state,
			hasMuvicard: hasMuvicard == 'null' ? 'ALL' : hasMuvicard,
		},
		() => this.refs.pagination.reload()
	)
}

const mapStateToProps = ({ admin, user }) => {
	return {
		...admin,
		user,
	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions,
		},
		dispatch
	)

const connectedsearchPageComponent = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ClientSearchPageComponent)
)

export { connectedsearchPageComponent as ModuleRootComponent }
